import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Settings, Cog } from 'lucide-react';

const SettingsDialog = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Settings className="h-5 w-5" />
            Agent Settings
          </DialogTitle>
        </DialogHeader>
        <div className="py-8 text-center text-muted-foreground">
          <Cog className="h-12 w-12 mx-auto mb-4 opacity-50" />
          <p>Agent-level global settings coming soon.</p>
          <p className="text-sm mt-2">Configure default behaviors, rate limits, and integrations.</p>
        </div>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SettingsDialog;